import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { G, Field, Flex, Button } from 'nallian-shared-ui/lib/components';
import {
  InputFieldValueComponent,
  CheckBoxFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';

const HostField = ({ field, index, submitting, handleRemoveFieldClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <G.Col>
        <Field
          type="text"
          label={index === 0 && t('host')}
          name={`${field}.host`}
          valueComponent={InputFieldValueComponent}
          disabled={submitting}
        />
      </G.Col>
      <G.Col>
        <Flex fluid>
          <Field
            toggle
            label={index === 0 && t('isPrimary')}
            name={`${field}.isPrimary`}
            valueComponent={CheckBoxFieldValueComponent}
            disabled={submitting}
          />
          <Button
            linkbutton
            iconbutton
            margin={index === 0 ? '0 0 0 1rem' : '-1rem 0 0 1.7rem'}
            icon="close"
            type="button"
            tabindex="-1"
            i={index}
            onClick={handleRemoveFieldClick}
          />
        </Flex>
      </G.Col>
    </>
  );
};

HostField.propTypes = {
  fields: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleRemoveFieldClick: PropTypes.func.isRequired,
};

export default HostField;
